<ng-container [formGroup]="parent.entryForm">
  <!-- new: not pristine (set programatically b e.g. address autocomplete) but invalid: danger-->

    <!-- new: not pristine (set programatically b e.g. address autocomplete) but invalid: danger-->
    <input formControlName="{{field.name}}" 
    [showStatusIconOn]="{ showOnControlStatus: field.statusIconOn ?? ['valid', 'invalid', 'pending'], invalidWhen: field.invalidWhen ?? 'touchedOrDirty' }"
    status="{{
            !field.required && !parent.entryForm.controls[field.name].touched && !parent.entryForm.controls[field.name].dirty ? 'basic' :
            parent.entryForm.controls[field.name].status == 'VALID' ? 'success' :
            parent.entryForm.controls[field.name].pristine && parent.entryForm.controls[field.name].status == 'INVALID' ? 'warning' : 
            parent.entryForm.controls[field.name].status == 'INVALID' ? 'danger' : 
            'primary'
        }}" 
    [type]="field.name == 'password' ? 'password' : 'text'" 
    nbInput 
    fullWidth 
    id="{{'input' + field.name}}" 
    placeholder="{{field.label}}"
    (blur)="parent.checkValidity(field.name)"/>
    

  <div
    *ngIf="
      parent.entryForm.get(field.name)?.hasError('apiError') &&
      parent.entryForm.get(field.name)?.touched
    "
    class="caption status-danger"
    style="margin-top: 5px"
  >
    {{ parent.entryForm.get(field.name)?.getError("apiError") }}
  </div>
</ng-container>